const orderDetailLangCN = {
    orderDetailsPage:"订单详情页面",
    good:"商品",
    orderStatus:"订单状态",
    orderAmount:"订单金额",
    changingOrRefund:"退货换货",
    changingOrRefundhit:"点击退换货",
    orderReference:"订单编号",
    creationTime:"创建时间",
    addresseeRegion:"收件人地区",
    direction:"收件人地址",
    addresseeName:"收件人姓名",
    phoneNumber:"收件人电话",
}

const orderDetailLangEN = {
    orderDetailsPage:"Orders details",
    good:"Goods",
    orderStatus:"Order status",
    orderAmount:"Order amount",
    changingOrRefund:"Returns a replacement",
    changingOrRefundhit:"Click return or exchange",
    orderReference:"Order reference",
    creationTime:"Payment date",
    addresseeRegion:"Consignee area",
    direction:"Consignee address",
    addresseeName:"Consignee name",
    phoneNumber:"Consignee phone",
}

const langPackage = {
    cn:orderDetailLangCN,
    en:orderDetailLangEN
}

export {langPackage}
